import { getAuth, sendSignInLinkToEmail } from "firebase/auth";
import { useCallback } from "react";

const auth = getAuth();

export const useSignIn = () => useCallback((email) => {
  const { host, pathname, protocol } = window.location;
  const url = `${protocol}//${host}/finishSignIn?redirection=${encodeURIComponent(pathname)}`;
  const actionCodeSettings = {
    url,
    handleCodeInApp: true,
  };
  return sendSignInLinkToEmail(auth, email, actionCodeSettings)
    .then(() => {
      // The link was successfully sent. Inform the user.
      // Save the email locally so you don't need to ask the user for it again
      // if they open the link on the same device.
      window.localStorage.setItem('emailForSignIn', email);
    });
}, []);
